import { render, staticRenderFns } from "./import.vue?vue&type=template&id=691ab8f4&scoped=true"
import script from "./import.vue?vue&type=script&lang=ts"
export * from "./import.vue?vue&type=script&lang=ts"
import style0 from "./import.vue?vue&type=style&index=0&id=691ab8f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691ab8f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('691ab8f4')) {
      api.createRecord('691ab8f4', component.options)
    } else {
      api.reload('691ab8f4', component.options)
    }
    module.hot.accept("./import.vue?vue&type=template&id=691ab8f4&scoped=true", function () {
      api.rerender('691ab8f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/import.vue"
export default component.exports